import { makeStyles } from '@material-ui/core';
import React from 'react';
import { MenuPrintConfig, MenuPrintPageProps } from './types';

export interface NewYorkMenuPageProps extends MenuPrintPageProps {
  originalColumnCount: number;
  Header: React.ElementType<{ config: MenuPrintConfig }>;
  Content: React.ElementType<{
    config: MenuPrintConfig;
    onColumnRef: MenuPrintPageProps['onColumnRef'];
    columns: MenuPrintPageProps['columns'];
  }>;
}

const NewYorkMenuPage: React.FC<NewYorkMenuPageProps> = ({ config, originalColumnCount, Header, Content, onColumnRef, columns }) => {
  const classes = useStyles();
  const showCenterDivider = config.groupBy === 'none' && originalColumnCount > 1;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `@page { size: 215.9mm 279.4mm; }` }} />
      <div className={classes.fullPage}>
        <div className={classes.frame}>
          <Header config={config} />
          <div className={classes.content}>
            {showCenterDivider && <div className={classes.centerDivider} />}
            <Content config={config} onColumnRef={onColumnRef} columns={columns} />
          </div>
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(() => ({
  fullPage: {
    height: '279.4mm',
    width: '215.9mm',
    boxSizing: 'border-box' as const,
    padding: '6mm'
  },
  frame: {
    height: '100%',
    width: '100%',
    border: '1px solid #000',
    boxSizing: 'border-box' as const,
    position: 'relative' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden'
  },
  content: {
    flex: 1,
    width: '100%',
    overflow: 'hidden',
    position: 'relative' as const,
    boxSizing: 'border-box' as const,
    paddingBottom: 10
  },
  centerDivider: {
    position: 'absolute' as const,
    top: 0,
    bottom: 0,
    left: '50%',
    width: 0,
    borderLeft: '1px solid #000',
    transform: 'translateX(-0.5px)',
    pointerEvents: 'none' as const
  }
}));

export default NewYorkMenuPage;
